import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

import { useTranslation } from 'react-i18next';
const URGENCY_BAR_HIDDEN_KEY = "urgency-bar-hidden";

export default function UrgencyBar() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      const hidden = sessionStorage.getItem(URGENCY_BAR_HIDDEN_KEY);
      if (hidden === "1") {
        setDismissed(true);
        setVisible(false);
      }
    } catch {
      // sessionStorage unavailable
    }
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    try {
      sessionStorage.setItem(URGENCY_BAR_HIDDEN_KEY, "1");
    } catch {
      // sessionStorage unavailable
    }
  };

  if (dismissed || !visible) return null;

  return (
    <div
      className="bg-amber-10 border-b border-amber-200"
      role="alert"
      aria-label={t('urgency_bar.early_access_offer')}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-10 flex items-center justify-center gap-3 relative">
        <p className="font-mono text-xs uppercase tracking-[0.15em] text-amber-900">
          <span aria-hidden="true" className="mr-1">🔥</span>
          EARLY ACCESS: First 100 businesses get 30% off forever.{" "}
          <span className="font-bold">47</span> spots remaining.
        </p>
        <Link
          to="/pricing"
          className="font-mono text-xs uppercase tracking-[0.15em] text-amber-900 underline underline-offset-2 hover:text-amber-700 font-bold"
          aria-label={t('urgency_bar.claim_your_spot_go_to_pricing')}
        >
          Claim Your Spot →
        </Link>
        <button
          onClick={handleDismiss}
          className="absolute right-6 lg:right-12 p-1 text-amber-700 hover:text-amber-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 rounded-sm"
          aria-label={t('urgency_bar.dismiss_early_access_banner')}
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
